function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var getSubTaskListPageStyle = function getSubTaskListPageStyle(prefixCls, token) {
  return _defineProperty({}, ".".concat(prefixCls), _defineProperty(_defineProperty(_defineProperty({
    display: 'flex',
    flexDirection: 'column',
    padding: '0 16px',
    width: '100%'
  }, ".searchInputWrap", _defineProperty({
    padding: '16px 0'
  }, ".searchInput", {
    borderRadius: '6px'
  })), ".countView", _defineProperty(_defineProperty({
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    alignItems: 'center',
    paddingBottom: '16px'
  }, ".countItem", _defineProperty(_defineProperty({
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
    height: '46px',
    borderBottom: '2px solid transparent'
  }, ".name", {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '22px'
  }), ".count", {
    fontSize: '12px',
    fontWeight: 330,
    textAlign: 'center',
    backgroundColor: '#F0F0F0',
    padding: '0 8px',
    borderRadius: '100px'
  })), ".active", {
    color: '#4C65ED',
    borderBottom: '2px solid #4C65ED'
  })), ".subTaskListWrap", {
    flex: 1,
    backgroundColor: '#fdf4fs',
    overflow: 'auto'
  }));
};